<template>
  <article class="contents-content">
    <div class="contents-content__content">
      <div class="content-in-area">
        <h1 class="content__title">등록된 주보보기</h1>
        <v-container>
          <v-row>
            <nav class="content-left-menu">
              <div style="display: flex">
                <v-btn @click="fetchPageMinus">
                  <v-icon>remove</v-icon>
                </v-btn>
                <div class="mt-1 me-3 ms-3">{{ page + 1 }} / {{ totalPages }}</div>
                <v-btn @click="fetchPagePlus">
                  <v-icon>add</v-icon>
                </v-btn>
              </div>
              <transition name="fade">
                <div v-if="paperList && paperList.length > 0">
                  <ul
                    class="content-menu-list"
                    ref="contentMenu"
                  >
                    <li
                      v-for="(filename, idx) in paperList"
                      :key="filename.id"
                      :class="['content-menu__item', {'is--active' : activeIndex === idx}]"
                      @click="setCurrentImg()"
                    >
                      <strong
                        class="menu__item-main"
                        @click="selectMainItem(idx)"
                      >
                        {{ filename.title }}
                      </strong>
                    </li>
                  </ul>
                </div>
                <p class="content--empty" v-if="paperList && paperList.length === 0">등록된 주보가 없습니다.</p>
              </transition>
            </nav>
            <div class="content--has-menu">
              <v-card outlined class="content__content">
                <v-card-text>
                  <v-container>
                    <v-row class="pa-2">
                      <v-col cols="12" class="pa-0">
                        <div class="weekly-paper-img-area">
                          <p class="content--empty" v-if="!selectedImgList && paperList">선택된 주보가 없습니다.</p>
                          <v-list-item-action v-if="selectedImgList && paperList">
                            <v-text-field hide-details class="pt-0" v-model="paperList[activeIndex].title"/>
                            <v-btn @click="setTitle()" color="primary" rounded depressed style="margin-left: 10px">제목 수정하기</v-btn>
                            <v-btn @click="remove()" outlined rounded color="error" style="margin-left: 10px">주보 삭제</v-btn>
                          </v-list-item-action>
                          <p/>
                          <v-list-item-action v-if="selectedImgList && paperList">
                            <v-text-field hide-details class="pt-0" v-model="paperList[activeIndex].printDate"/>
                            <v-btn @click="setPrintDate()" color="primary" rounded depressed style="margin-left: 10px">표시날짜 변경하기</v-btn>
                          </v-list-item-action>
                          <p/>
                          <v-list-item-action v-if="selectedImgList && paperList">
                            <v-text-field hide-details class="pt-0" v-model="paperList[activeIndex].priority"/>
                            <v-btn @click="setPriority()" color="primary" rounded depressed style="margin-left: 10px">우선순위 변경하기</v-btn>
                            <h3 style="margin-left: 10px; margin-bottom: 5px">숫자가 클수록 앱에서 맨 위에 표시됩니다. default: 0</h3>
                          </v-list-item-action>
                          <p/>

                          <div style="display: flex; flex-wrap: wrap">
                            <div class="pa-3 ma-2" style="width: 250px; background-color: #598fad; border-radius:10px"
                                 v-for="(src, i) in selectedImgList"
                                 :key="i">
                              <img
                                  :src="src"
                                  :key="i"
                                  alt=""
                                  width="226px"
                              >
                              <div style="color: white; font-size: 17px; text-align: center">
                                {{ i + 1 }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </div>
          </v-row>
        </v-container>
      </div>
    </div>
  </article>
</template>

<script>
import { weeklyPaper, HOST } from '../api'
import eventBus from '../utils/eventBus'

export default {
  components: {
  },
  data () {
    return {
      page: 0,
      totalPages: 1,
      paperList: null,
      selectedImgList: null,
      activeIndex: null,
      activeChildIndex: null
    }
  },
  created () {
    this.fetchList()
  },
  methods: {
    async fetchPagePlus () {
      this.page++
      if (this.totalPages <= this.page) {
        this.page = this.totalPages - 1
      }
      await this.fetchList()
    },
    async fetchPageMinus () {
      this.page--
      if (this.page <= 0) {
        this.page = 0
      }
      await this.fetchList()
    },
    async fetchList () {
      const { data } = await weeklyPaper.list(this.page, 10)
      this.totalPages = data.totalPages
      this.paperList = data.content
    },
    async remove () {
      const filename = this.paperList[this.activeIndex].date
      await weeklyPaper.remove(filename)
      this.paperList = null
      this.selectedImgList = null
      await this.fetchList()
    },
    async setTitle () {
      try {
        eventBus.$emit('showLoading')
        const body = {
          title: this.paperList[this.activeIndex].title
        }
        await weeklyPaper.setTitle(this.paperList[this.activeIndex].date, body)
        eventBus.$emit('alert', { active: true, text: '등록 되었습니다.' })
      } catch (e) {
        eventBus.$emit('alert', { active: true, text: '에러!' })
      } finally {
        eventBus.$emit('hideLoading')
      }
    },
    async setPrintDate () {
      try {
        eventBus.$emit('showLoading')
        const body = {
          date: this.paperList[this.activeIndex].printDate
        }
        await weeklyPaper.setPrintDate(this.paperList[this.activeIndex].date, body)
        eventBus.$emit('alert', { active: true, text: '등록 되었습니다.' })
      } catch (e) {
        eventBus.$emit('alert', { active: true, text: '에러! yyyyMMdd 형식으로 입력해주세요' })
      } finally {
        eventBus.$emit('hideLoading')
      }
    },
    async setPriority () {
      try {
        eventBus.$emit('showLoading')
        const body = {
          priority: this.paperList[this.activeIndex].priority
        }
        await weeklyPaper.setPriority(this.paperList[this.activeIndex].date, body)
        eventBus.$emit('alert', { active: true, text: '등록 되었습니다.' })
      } catch (e) {
        eventBus.$emit('alert', { active: true, text: '에러!' })
      } finally {
        eventBus.$emit('hideLoading')
      }
    },
    setCurrentImg () {
      this.selectedImgList = this.paperList[this.activeIndex].images
        .map((v) => `${HOST}/api/v1/images/${v}`)
    },
    selectMainItem (index) {
      this.activeIndex = index
      this.activeChildIndex = null
    }
  }
}
</script>

<style lang="scss">
.weekly-paper-img-area {
  .content--empty {
    margin-top: 80px;
    text-align: center;
    font-size: 1rem;
  }
}
</style>
